import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import styled, { a2bTheme } from '../../../../../theme/styled';
import { progressiveLoading } from '../../../../../commons/styles/animations';

interface StyledProps {
  theme: a2bTheme;
}

const CounterPartInfo = styled.ul`
  list-style: none;
  padding: 0;
  margin: 32px 0 0 0;
`;
const CounterPartInfoLine = styled.li`
  padding: 16px 0;
  display: flex;
  flex-wrap: nowrap;
  border-bottom: 1px solid ${({ theme }: StyledProps) => theme.colors.grey3};

  &:last-child {
    border-bottom: none;
  }
`;

const InfoDesc = styled(Paragraph4)`
  flex-grow: 1;
`;
const InfoVal = styled.span`
  font-weight: ${({ theme }: StyledProps) => theme.fontWeights.medium};
  font-size: ${({ theme }: StyledProps) => theme.sizes.m};

  &:empty {
    ${progressiveLoading()}
  }
`;

const PhoneLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.bluePrimary};

  &:empty {
    height: 18px;
    display: block;
    ${progressiveLoading({ randomWidth: true })}
  }
`;

export default {
  CounterPartInfo,
  CounterPartInfoLine,
  InfoDesc,
  InfoVal,
  PhoneLink,
};
